export const rowIndex = (page: number | undefined, rowPerPage: number | undefined, itemIndex: number) => {
  return ((page ?? 1) - 1) * (rowPerPage ?? 10) + (itemIndex + 1);
};
